import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://opbzyxvqqkuymouukczk.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9wYnp5eHZxcWt1eW1vdXVrY3prIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQyNjQzMDgsImV4cCI6MjA3OTg0MDMwOH0.TQtvx8rz1FI9Jkcbb3wKOBXwxAvwQg9J9p4lnrrDY5I';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
